/**
 *	@copyright	KARD.
 */

import * as Cfg from '../../_cfg'
import {Lambda, Core} from '../../api/AWS'

/**
 */
export const TempSMS_List = ( last_key ) =>
{
    return async (d, gs) =>
    {
        try
        {
            const aws_lambda = new Lambda( {} )

            const aws_core = new Core( {} )
            const cur_usr = await aws_core.currentuser()

            const p_list = {
                actType: 'comm',
                act: 'comm:sms:temp:list',
                // c_id: gs().__auth.orgId,
                c_id: window.localStorage.getItem( 'org_id' ),

                usr: {
                    ...cur_usr.attributes,
                    username: cur_usr.username,
                },

                data: {last_key},
            }

            console.log( 'actions/TempSMS_List: p_list: ', p_list )

            const resp_list = await aws_lambda.Invoke( p_list, Cfg.lambda[Cfg.stage].admin )

            console.log( 'actions/TempSMS_List: resp_list: ', resp_list )

            //
            return resp_list
        }
        catch( err )
        {
            console.warn( 'actions/TempSMS_List: err: ', err )

            return Promise.reject( err )
        }
    }
}   // TempSMS_List

/**
 */
export const TempSMS_Details = ( temp_obj ) =>
{
    return async (d, gs) =>
    {
        try
        {
            const aws_lambda = new Lambda( {} )

            const aws_core = new Core( {} )
            const cur_usr = await aws_core.currentuser()

            const p_list = {
                actType: 'comm',
                act: 'comm:sms:temp:get',
                // c_id: gs().__auth.orgId,
                c_id: window.localStorage.getItem( 'org_id' ),

                usr: {
                    ...cur_usr.attributes,
                    username: cur_usr.username,
                },

                data: {...temp_obj},
            }

            console.log( 'actions/TempSMS_Details: p_list: ', p_list )

            const resp_list = await aws_lambda.Invoke( p_list, Cfg.lambda[Cfg.stage].admin )

            console.log( 'actions/TempSMS_Details: resp_list: ', resp_list )

            //
            return resp_list
        }
        catch( err )
        {
            console.warn( 'actions/TempSMS_Details: err: ', err )

            return Promise.reject( err )
        }
    }
}   // TempSMS_Details

/**
 */
export const TempSMS_Create = ( temp_obj ) =>
{
    return async (d, gs) =>
    {
        try
        {
            const aws_lambda = new Lambda( {} )

            const aws_core = new Core( {} )
            const cur_usr = await aws_core.currentuser()

            const p_list = {
                actType: 'comm',
                act: 'comm:sms:temp:new',
                // c_id: gs().__auth.orgId,
                c_id: window.localStorage.getItem( 'org_id' ),

                usr: {
                    ...cur_usr.attributes,
                    username: cur_usr.username,
                },

                data: {...temp_obj},
            }

            console.log( 'actions/TempSMS_Details: p_list: ', p_list )

            const resp_list = await aws_lambda.Invoke( p_list, Cfg.lambda[Cfg.stage].admin )

            console.log( 'actions/TempSMS_Details: resp_list: ', resp_list )

            //
            return resp_list
        }
        catch( err )
        {
            console.warn( 'actions/TempSMS_Details: err: ', err )

            return Promise.reject( err )
        }
    }
}   // TempSMS_Create

/**
 */
export const TempSMS_Edit = ( temp_obj ) =>
{
    return async (d, gs) =>
    {
        try
        {
            const aws_lambda = new Lambda( {} )

            const aws_core = new Core( {} )
            const cur_usr = await aws_core.currentuser()

            const p_list = {
                actType: 'comm',
                act: 'comm:sms:temp:edit',
                // c_id: gs().__auth.orgId,
                c_id: window.localStorage.getItem( 'org_id' ),

                usr: {
                    ...cur_usr.attributes,
                    username: cur_usr.username,
                },

                data: {...temp_obj},
            }

            console.log( 'actions/TempSMS_Edit: p_list: ', p_list )

            const resp_list = await aws_lambda.Invoke( p_list, Cfg.lambda[Cfg.stage].admin )

            console.log( 'actions/TempSMS_Edit: resp_list: ', resp_list )

            //
            return resp_list
        }
        catch( err )
        {
            console.warn( 'actions/TempSMS_Edit: err: ', err )

            return Promise.reject( err )
        }
    }
}   // TempSMS_Edit

/**
 */
export const TempSMS_Del = ( temp_obj ) =>
{
    return async (d, gs) =>
    {
        try
        {
            const aws_lambda = new Lambda( {} )

            const aws_core = new Core( {} )
            const cur_usr = await aws_core.currentuser()

            const p_list = {
                actType: 'comm',
                act: 'comm:sms:temp:del',
                // c_id: gs().__auth.orgId,
                c_id: window.localStorage.getItem( 'org_id' ),

                usr: {
                    ...cur_usr.attributes,
                    username: cur_usr.username,
                },

                data: {...temp_obj},
            }

            console.log( 'actions/TempSMS_Del: p_list: ', p_list )

            const resp_list = await aws_lambda.Invoke( p_list, Cfg.lambda[Cfg.stage].admin )

            console.log( 'actions/TempSMS_Del: resp_list: ', resp_list )

            //
            return resp_list
        }
        catch( err )
        {
            console.warn( 'actions/TempSMS_Del: err: ', err )

            return Promise.reject( err )
        }
    }
}   // TempSMS_Del

